import Filter from 'bad-words';

// Function to check if a string contains any forbidden words
const profanityCheck = (input) => {
  const filter = new Filter();
  filter.addWords('poo','suck');
  return filter.isProfane(input);
};

export default profanityCheck;